export const backEn = {
  status: {
    open: 'Open',
    new: 'New',
    closed: 'Closed',
    pending: 'Pending',
    finished: 'Finished',
  },
  states: {
    true: 'Active',
    false: 'Inactive',
  },
  sport: {
    soccer: 'Soccer',
    basket: 'Basket',
    csgo: 'CS:GO',
    lol: 'League of Legends'
  },
  role: {
     df: 'Defender',
     gk: 'Goalkeeper',
     mf: 'Midfielder',
     fw: 'Forward',
     top: 'Top',
     mid: 'Middle',
     bot: 'Bottom',
     jun: 'Jungle',
     sup: 'Support',
     pl: 'Player',
  },
};
